import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--charcoal)] px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/assets/seraphina-logo-hero.png" alt="Seraphina" className="h-16 w-16 object-contain mx-auto mb-4" />
          <h1 className="font-display text-4xl text-[#F3E9DC]">Reset Password</h1>
          <p className="text-[#c9bba9] text-sm mt-2 tracking-widest uppercase">Seraphina Admin</p>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="bg-[#46413b] rounded-2xl p-8 border border-[#5a544c] text-center">
            <p className="text-[#F3E9DC] leading-relaxed">
              If an account exists for <span className="text-[var(--gold-soft)]">{email}</span>, a password reset link has been sent.
              Check your inbox (and spam folder). The link expires in 1 hour.
            </p>
            <Link to="/admin/login" className="btn-gold rounded-full px-8 py-3 inline-block mt-6">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form" className="bg-[#46413b] rounded-2xl p-8 border border-[#5a544c]">
            <p className="text-[#c9bba9] text-sm mb-5 leading-relaxed">
              Enter your admin email and we'll send you a link to reset your password.
            </p>
            <label className="eyebrow text-[var(--gold-soft)]">Email</label>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-2 mb-5 bg-[#3B3733] border-[#5a544c] text-[#F3E9DC]" placeholder="you@example.com" />
            {error && <p data-testid="forgot-error" className="text-red-300 text-sm mb-4">{error}</p>}
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-gold rounded-full w-full py-3.5 disabled:opacity-60">
              {loading ? "Sending…" : "Send Reset Link"}
            </button>
          </form>
        )}

        <p className="text-center text-[#c9bba9] text-xs mt-6">
          <Link to="/admin/login" className="hover:text-[var(--gold-soft)] transition-colors">← Back to login</Link>
        </p>
      </div>
    </div>
  );
}
